import { formatDistanceToNow } from "date-fns";
import { fr } from "date-fns/locale";

import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";

import type { ClaimWithRelations } from "../api/use-claim";
import { legalStepAlertClasses } from "../lib/legal-steps";
import { AbandonTypeBadge } from "./abandon-type-badge";

/** Port of ClaimStatePreview.vue. */
export function ClaimStatePreview({ claim }: { claim: ClaimWithRelations }) {
  const lastEvent = claim.claimEvents.length ? claim.claimEvents[claim.claimEvents.length - 1] : undefined;
  const isAbandonState = claim.claimState.displayName.toLowerCase().includes("abandon");
  const abandonType = claim.legalSpecification.abandonType;

  return (
    <div role="alert" className={`border-b px-6 py-2 ${legalStepAlertClasses[claim.claimLegalStep.name]}`}>
      <div className="my-2 text-sm">
        <div className="flex w-full items-center justify-between">
          <Tooltip>
            <TooltipTrigger render={<p />}>
              Étape : <span className="font-medium">{claim.claimState.displayName}</span>
            </TooltipTrigger>
            <TooltipContent side="right">Fait suite à « {lastEvent?.eventType.displayName} »</TooltipContent>
          </Tooltip>
          <div className="flex items-center gap-3">
            {isAbandonState && abandonType ? <AbandonTypeBadge abandonType={abandonType} /> : null}
            {claim.stateUpdatedAt ? (
              <span className="text-xs italic">
                Il y a {formatDistanceToNow(new Date(claim.stateUpdatedAt), { locale: fr })}
              </span>
            ) : null}
          </div>
        </div>
      </div>
      {claim.claimState.description ? (
        <div className="flex py-2 text-left text-sm leading-6">{claim.claimState.description}</div>
      ) : null}
      {lastEvent?.eventType.description ? (
        <div className="flex py-2 text-left text-sm leading-6">
          <p className="italic">{lastEvent.eventType.description}</p>
        </div>
      ) : null}
    </div>
  );
}
